/** Supported color schemes for `@nrx/ui` surfaces. */
export type ColorScheme = 'light' | 'dark';

const STORAGE_KEY = 'nrx-ui-color-scheme';

/**
 * Resolve the initial color scheme from storage or system preference.
 *
 * @param stored - Value from localStorage, or null when unset.
 */
export function resolveColorScheme(stored: string | null): ColorScheme {
  if (stored === 'dark' || stored === 'light') return stored;
  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return 'dark';
  }
  return 'light';
}

/** Read the persisted color scheme preference. */
export function getStoredColorScheme(): ColorScheme {
  if (typeof window === 'undefined') return 'light';
  return resolveColorScheme(localStorage.getItem(STORAGE_KEY));
}

/**
 * Apply the color scheme to the document root and persist the choice.
 *
 * @param scheme - Light or dark scheme to activate.
 */
export function applyColorScheme(scheme: ColorScheme): void {
  document.documentElement.dataset['theme'] = scheme;
  document.documentElement.style.colorScheme = scheme;
  localStorage.setItem(STORAGE_KEY, scheme);
}
